module.exports = __webpack_public_path__ + "img/mockup-home.23f77dfd.png";